import { YearCoverage } from '@shared/api/types';
import Text from '@shared/components/content/text';
import { cn } from '@shared/lib/utils';

interface DataCoverageBarsProps {
  siteName: string;
  yearData: YearCoverage;
  monthLabels: string[];
  className?: string;
}

export function DataCoverageBars({
  siteName,
  yearData,
  monthLabels,
  className,
}: DataCoverageBarsProps) {
  const hasOnlyYearData =
    yearData.hasData && yearData.months.every((m) => !m.hasData);

  return (
    <div className={cn('w-full', className)}>
      <div className="mb-2 grid grid-cols-12 gap-2">
        {monthLabels.map((monthName) => (
          <Text
            key={monthName}
            variant="subtle"
            className="text-center text-xs font-light"
          >
            {monthName}
          </Text>
        ))}
        {hasOnlyYearData ? (
          <div
            className={
              'col-span-12 h-2 rounded-[2px] border-2 border-teal-400 bg-teal-400'
            }
          />
        ) : (
          yearData.months.map((month) => (
            <div
              key={`${siteName}-${month.name}`}
              className={cn(
                'col-span-1 h-2 rounded-[2px] border-2 border-teal-200 bg-none',
                {
                  'bg-teal-400 border-teal-400': month.hasData,
                }
              )}
            />
          ))
        )}
      </div>
    </div>
  );
}
